export function clearGACookies() {
  if (typeof document === "undefined") return;
  const cookies = document.cookie.split("; ");
  const isSecure =
    typeof window !== "undefined" && window.location.protocol === "https:";
  const opts = `Path=/; SameSite=Lax${isSecure ? "; Secure" : ""}`;
  cookies.forEach((c) => {
    const name = c.split("=")[0];
    if (name === "_ga" || name.startsWith("_ga_")) {
      document.cookie = `${name}=; Max-Age=0; ${opts}`;
    }
  });
}
